import { getCategoryChips } from '../../utils/metricTags';
import './Analytics.scss';

export default function CategoryChips({ value, onChange, chips }) {
    const items = chips || getCategoryChips();

    return (
        <div className="analytics-chips">
            {items.map(({ key, label }) => (
                <button
                    key={key || 'all'}
                    type="button"
                    className={`analytics-chips__chip${value === key ? ' analytics-chips__chip--active' : ''}`}
                    onClick={() => onChange(key)}
                >
                    {label}
                </button>
            ))}
        </div>
    );
}
